import { InitialStateType, TUser } from './AuthContext';

// Generic function to select the right payload
type ActionMap<M extends { [index: string]: unknown }> = {
    [Key in keyof M]: M[Key] extends undefined
        ? {
              type: Key;
          }
        : {
              type: Key;
              payload: M[Key];
          };
};

export enum Types {
    Login = 'LOGIN',
    Logout = 'LOGOUT',
}

type AuthPayload = {
    [Types.Login]: {
        isAuthenticated: boolean;
        user: TUser;
    };
    [Types.Logout]: {
        isAuthenticated: boolean;
        user: TUser;
    };
};

export type AuthActions = ActionMap<AuthPayload>[keyof ActionMap<AuthPayload>];

export const AuthReducer = (
    state: InitialStateType,
    action: { type: string; payload: InitialStateType },
): InitialStateType => {
    switch (action.type) {
        case 'LOGIN':
            localStorage.setItem('user', JSON.stringify({ user: action.payload.user, isAuthenticated: true }));
            return {
                ...state,
                isAuthenticated: true,
                user: { ...action.payload.user },
            };
        case 'LOGOUT':
            localStorage.clear();
            return {
                ...state,
                isAuthenticated: false,
                user: {
                    email: '',
                    name: '',
                    accessToken: '',
                    id: '',
                },
            };
        default:
            return state;
    }
};
